// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"blogLayout-module--wrapper--usgLL"};